import React from 'react';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BugReportIcon from '@mui/icons-material/BugReport';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

type WorkItemIconPropsType = {
  workType: string | undefined
}

export const WorkItemIcon = React.memo((props: WorkItemIconPropsType) => {
  let component
  switch (props.workType) {
    case 'Task':
      component = <AssignmentTurnedInIcon fontSize="small" style={{ color: "orange",verticalAlign:"middle" }} />;
      break;
    case 'Bug':
      component = <BugReportIcon  fontSize="small" style={{ color: 'cc0000', verticalAlign:"middle" }} />;
      break;
    case 'User Story':
      component = <MenuBookIcon fontSize="small" style={{ color: '#00bfff', verticalAlign:"middle" }} />;
      break;
    case 'Feature':
      component = <EmojiEventsIcon fontSize="small" style={{ color: "#8a2be2", verticalAlign:"middle" }} />;
      break;
    default:
      component = <NewReleasesIcon fontSize="small" style={{ color: 'red', verticalAlign:"middle" }} />;
      break;
  }
  return (
    component
  )
})